import axios from "axios";
import { translations } from "../i18n/translations";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;

export const api = axios.create({
  baseURL: API,
  withCredentials: true,
});

export const CATEGORIES = [
  "Wood",
  "Bricks",
  "Concrete",
  "Metal",
  "Glass",
  "Tiles",
  "Insulation",
  "DoorsWindows",
  "Roofing",
  "Other",
];

// Unit codes are stable; labels come from translations.
export const UNIT_CODES = ["pcs", "m", "m2", "m3", "kg", "ton", "pallet"];

export function getCategoryLabel(code, lang = "sv") {
  const dict = translations[lang] || translations.sv;
  return dict[`cat.${code}`] || translations.sv[`cat.${code}`] || code;
}

export function getUnitLabel(code, lang = "sv") {
  const dict = translations[lang] || translations.sv;
  return dict[`unit.${code}`] || translations.sv[`unit.${code}`] || code;
}

export const QUALITIES = ["A-grade", "B-grade", "C-grade"];

export const MACHINE_TYPES = [
  "borrmaskin", "kap", "sag", "slipmaskin", "vibratorplatta",
  "minigravare", "lift", "stallning", "blandare", "annat",
];
export const MACHINE_STATUSES = ["tillganglig", "bokad", "utlamnad", "service", "trasig"];
export const INVENTORY_STATUSES = ["ledig", "ute", "trasig"];
export const BOOKING_STATUSES = ["bokad", "godkand", "utlamnad", "aterlamnad", "avbruten"];

export const FUEL_TYPES = ["diesel", "bensin", "el", "hvo", "hybrid", "gas"];
export const VEHICLE_STATUSES = ["aktiv", "service", "ur_drift", "salt"];
export const SERVICE_TYPES = ["regular", "tire", "repair", "inspection_prep"];

export function fileUrl(path) {
  if (!path) return null;
  if (path.startsWith("http")) return path;
  return `${API}/files/${path}`;
}
